<app-engines-header
    [dges]="selectedDge"
    (filtersChanged)="onFilterChange($event)">
</app-engines-header>

<div class="d-flex">
    <app-engines-table
        (selectedRow)="onCheckChange()"
        (tableLoaded)="onTableLoaded($event)"
        class="col-12">
    </app-engines-table>
</div>